import {
    CREATE_FABRIC_PO_DETAILS_REQUEST_DK,
    CREATE_FABRIC_PO_DETAILS_SUCCESS_DK,
    CREATE_FABRIC_PO_DETAILS_FAILURE_DK,
    DELETE_FABRIC_PO_DETAILS_REQUEST_DK,
    DELETE_FABRIC_PO_DETAILS_SUCCESS_DK,
    DELETE_FABRIC_PO_DETAILS_FAILURE_DK,
    FETCH_SINGLE_FABRIC_PO_DETAILS_REQUEST_DK,
    FETCH_SINGLE_FABRIC_PO_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_FABRIC_PO_DETAILS_FAILURE_DK,
    FETCH_FABRIC_PO_DETAILS_REQUEST_DK,
    FETCH_FABRIC_PO_DETAILS_SUCCESS_DK,
    FETCH_FABRIC_PO_DETAILS_FAILURE_DK,
    UPDATE_FABRIC_PO_DETAILS_REQUEST_DK,
    UPDATE_FABRIC_PO_DETAILS_SUCCESS_DK,
    UPDATE_FABRIC_PO_DETAILS_FAILURE_DK,
    RESET_FABRIC_PO_DETAILS_INFO_DK,
    CREATE_FABRIC_PO_DETAILS_FORM_DK,
    UPDATE_FABRIC_PO_DETAILS_FORM_DK,
    FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_SUCCESS_DK,
    FETCH_FABRIC_PO_DETAILS_GROUP_LIST_REQUEST_DK,
    FETCH_FABRIC_PO_DETAILS_GROUP_LIST_SUCCESS_DK,
    FETCH_FABRIC_PO_PREVIOUS_LIST_REQUEST_DK,
    FETCH_FABRIC_PO_PREVIOUS_LIST_FAILURE_DK,
    FETCH_FABRIC_PO_PREVIOUS_LIST_SUCCESS_DK,
    FABRIC_CLOSE_BTN_POST_REQUEST,
    FABRIC_CLOSE_BTN_POST_FALIURE,
    FABRIC_CHECK_ALL_UPDATE_REQUEST,
    FABRIC_CHECK_ALL_UPDATE_FALIURE
} from './fabricPoDetails.actionsType';

export const FABRIC_PO_DETAILS_DK = 'fabricPoDetailsDK';

let initialState = {
    loading: false,
    fabricPoDetails: [],
    fabricPoDetailsWithoutId: [],
    groupList: [],
    fabricPoDetailsForm: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    previousList: [],
    selectedState: {},
    errorMessage: ''
};

export let fabricPoDetailsDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_FABRIC_PO_DETAILS_REQUEST_DK:
        case CREATE_FABRIC_PO_DETAILS_REQUEST_DK:
        case UPDATE_FABRIC_PO_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_FABRIC_PO_DETAILS_REQUEST_DK:
        case DELETE_FABRIC_PO_DETAILS_REQUEST_DK:
        case FETCH_FABRIC_PO_PREVIOUS_LIST_REQUEST_DK:
        case FETCH_FABRIC_PO_DETAILS_GROUP_LIST_REQUEST_DK:
        case FABRIC_CLOSE_BTN_POST_REQUEST:
        case FABRIC_CHECK_ALL_UPDATE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_FABRIC_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricPoDetails: updatePayload
            };
        case FETCH_FABRIC_PO_PREVIOUS_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousList: updatePayload
            };
        case FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricPoDetailsWithoutId: updatePayload
            };
        case FETCH_FABRIC_PO_DETAILS_GROUP_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                groupList: updatePayload
            };
        case CREATE_FABRIC_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case UPDATE_FABRIC_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_FABRIC_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricPoDetailsForm: updatePayload
            };
        case DELETE_FABRIC_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case RESET_FABRIC_PO_DETAILS_INFO_DK:
            return {
                ...state,
                fabricPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case CREATE_FABRIC_PO_DETAILS_FORM_DK:
        case UPDATE_FABRIC_PO_DETAILS_FORM_DK:
            return {
                ...state,
                loading: false,
                fabricPoDetailsForm: {
                    ...state.fabricPoDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_FABRIC_PO_DETAILS_FAILURE_DK:
        case CREATE_FABRIC_PO_DETAILS_FAILURE_DK:
        case UPDATE_FABRIC_PO_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_FABRIC_PO_DETAILS_FAILURE_DK:
        case DELETE_FABRIC_PO_DETAILS_FAILURE_DK:
        case FETCH_FABRIC_PO_PREVIOUS_LIST_FAILURE_DK:
        case FABRIC_CHECK_ALL_UPDATE_FALIURE:
        case FABRIC_CLOSE_BTN_POST_FALIURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
